// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastLibraryAd1-cls1_H2h","cls2":"PodcastLibraryAd1-cls2_L8t PodcastLibraryAd1-cls1_H2h"};